import HrmService from '@/api/HrmService'

export const transformContacts = (input = []) => {
  return input.map((item) => {
    return {
      'platform': item.platform,
      'source': item.source,
    }
  })
}

export const transformEmployee = (input = {}) => {
  return {
    'empId': input.emp_id,
    'name': input.name,
    'gender': input.gender,
    'birthdate': input.birthdate,
    'departmentId': input.department_id,
    'positionId': input.position_id,
    'contacts': transformContacts(input.contacts || []),
    'address': input.address,
    'wageAmount': input.wage_amount,
    'wageType': input.wage_type,
    'startWorkingDate': input.start_working_date,
    'note': input.note,
    'tags': input.tags,
    'createdAt': input.created_at,
    'departmentName': input.department_name,
    'positionName': input.position_name,
  }
}

export const transformEmployees = (input = []) => {
  return input.map((item) => transformEmployee(item))
}

export const transformDepartment = (input = {}) => {
  return {
    'depId': input.dep_id,
    'name': input.name,
    'appliedCount': input.applied_count,
    'empIds': input.emp_ids,
    'createdAt': input.created_at,
  }
}

export const transformDepartments = (input = []) => {
  return input.map((item) => transformDepartment(item))
}

export const transformPosition = (input = {}) => {
  return {
    'positionId': input.position_id,
    'name': input.name,
    'appliedCount': input.applied_count,
    'empIds': input.emp_ids,
    'createdAt': input.created_at,
  }
}

export const transformPositions = (input = []) => {
  return input.map((item) => transformPosition(item))
}

export default {
  namespaced: true,

  state: {
    employeeList: transformEmployees([]),
    employeeSingle: transformEmployee({}),
    departmentList: transformDepartments([]),
    departmentSingle: transformDepartment({}),
    positionList: transformPositions([]),
    positionSingle: transformPosition({}),
  },

  mutations: {
    setEmployeeList (state, data) {
      state.employeeList = transformEmployees(data)
    },
    setEmployeeSingle (state, data) {
      state.employeeSingle = transformEmployee(data)
    },
    setDepartmentList (state, data) {
      state.departmentList = transformDepartments(data)
    },
    setDepartmentSingle (state, data) {
      state.departmentSingle = transformDepartment(data)
    },
    setPositionList (state, data) {
      state.positionList = transformPositions(data)
    },
    setPositionSingle (state, data) {
      state.positionSingle = transformPosition(data)
    },
  },

  actions: {
    async getEmployeeList ({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getEmployeeList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getEmployeeList')

        const response = await HrmService.getEmployeeList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getEmployeeList')

        result = response.data

        if (result.success) {
          commit('setEmployeeList', result.data)
          this.dispatch('setPagination', result.meta)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getEmployeeSingle ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getEmployeeSingle') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getEmployeeSingle')

        const response = await HrmService.getEmployeeSingle(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getEmployeeSingle')

        result = response.data

        if (result.success) {
          commit('setEmployeeSingle', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async createEmployee ({ commit }, data = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('createEmployee') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'createEmployee')

        const response = await HrmService.createEmployee(data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'createEmployee')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateEmployee ({ commit }, { id, data }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateEmployee') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateEmployee')

        const response = await HrmService.updateEmployee(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateEmployee')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async deleteEmployee ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('deleteEmployee') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'deleteEmployee')

        const response = await HrmService.deleteEmployee(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'deleteEmployee')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getDepartmentList ({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getDepartmentList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getDepartmentList')

        const response = await HrmService.getDepartmentList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getDepartmentList')

        result = response.data

        if (result.success) {
          commit('setDepartmentList', result.data)
          this.dispatch('setPagination', result.meta)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getDepartmentSingle ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getDepartmentSingle') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getDepartmentSingle')

        const response = await HrmService.getDepartmentSingle(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getDepartmentSingle')

        result = response.data

        if (result.success) {
          commit('setDepartmentSingle', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async createDepartment ({ commit }, data = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('createDepartment') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'createDepartment')

        const response = await HrmService.createDepartment(data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'createDepartment')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateDepartment ({ commit }, { id, data = {} }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateDepartment') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateDepartment')

        const response = await HrmService.updateDepartment(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateDepartment')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updateDepartmentAssign ({ commit }, { id, data = {} }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updateDepartmentAssign') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updateDepartmentAssign')

        const response = await HrmService.updateDepartmentAssign(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updateDepartmentAssign')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async deleteDepartment ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('deleteDepartment') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'deleteDepartment')

        const response = await HrmService.deleteDepartment(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'deleteDepartment')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getPositionList ({ commit }, params = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getPositionList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getPositionList')

        const response = await HrmService.getPositionList(params)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getPositionList')

        result = response.data

        if (result.success) {
          commit('setPositionList', result.data)
          this.dispatch('setPagination', result.meta)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async getPositionSingle ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getPositionSingle') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getPositionSingle')

        const response = await HrmService.getPositionSingle(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getPositionSingle')

        result = response.data

        if (result.success) {
          commit('setPositionSingle', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async createPosition ({ commit }, data = {}) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('createPosition') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'createPosition')

        const response = await HrmService.createPosition(data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'createPosition')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updatePosition ({ commit }, { id, data = {} }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updatePosition') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updatePosition')

        const response = await HrmService.updatePosition(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updatePosition')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async updatePositionAssign ({ commit }, { id, data = {} }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('updatePositionAssign') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'updatePositionAssign')

        const response = await HrmService.updatePositionAssign(id, data)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'updatePositionAssign')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
    async deletePosition ({ commit }, id) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('deletePosition') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'deletePosition')

        const response = await HrmService.deletePosition(id)

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'deletePosition')

        result = response.data

        if (result.success) {

        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/Hrm.js